import React from 'react';
import { Box, Container, Grid, Paper, Typography } from '@mui/material';
import {
  People,
  Group,
  Assignment,
  TrendingUp,
} from '@mui/icons-material';

const AdminDashboard: React.FC = () => {
  const stats = [
    {
      title: 'Toplam Kullanıcı',
      value: '1,234',
      icon: <People sx={{ fontSize: 40 }} />,
      color: '#667eea',
      bgColor: '#667eea20',
    },
    {
      title: 'Aktif Gruplar',
      value: '56',
      icon: <Group sx={{ fontSize: 40 }} />,
      color: '#f093fb',
      bgColor: '#f093fb20',
    },
    {
      title: 'Bekleyen Talepler',
      value: '12',
      icon: <Assignment sx={{ fontSize: 40 }} />,
      color: '#4facfe',
      bgColor: '#4facfe20',
    },
    {
      title: 'Bugünkü Aktivite',
      value: '+23%',
      icon: <TrendingUp sx={{ fontSize: 40 }} />,
      color: '#43e97b',
      bgColor: '#43e97b20',
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Hoş geldiniz! İşte sistemin genel durumu.
      </Typography>

      <Grid container spacing={3}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 3,
                border: '1px solid #e0e0e0',
                transition: 'all 0.3s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    {stat.title}
                  </Typography>
                  <Typography variant="h4" fontWeight="bold">
                    {stat.value}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: 2,
                    backgroundColor: stat.bgColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: stat.color,
                  }}
                >
                  {stat.icon}
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Son Aktiviteler */}
      <Box sx={{ mt: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: 3,
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Son Aktiviteler
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Yakında eklenecek...
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default AdminDashboard;

